import type { TransportFailureKind } from './bookingFlowAnalyticsTypes.ts';

const CONTROLLED_REJECTION_STATUSES = new Set([400, 409, 422]);
const CONTROLLED_REJECTION_CODES = new Set([
  'capacity_full',
  'outside_bookable_window',
  'validation_failed',
  'unit_unavailable',
  'invalid_date',
  'invalid_time',
  'invalid_headcount',
]);

export const isControlledReservationRejection = (input: { status?: number; data?: unknown }) => {
  if (typeof input.status !== 'number' || !CONTROLLED_REJECTION_STATUSES.has(input.status)) return false;
  const data = input.data as { error?: unknown; code?: unknown } | null;
  const code = typeof data?.error === 'string' ? data.error : typeof data?.code === 'string' ? data.code : null;
  return Boolean(code && CONTROLLED_REJECTION_CODES.has(code));
};

export const resolveBookingFlowTransportFailureKind = (error: unknown): TransportFailureKind | null => {
  const errorRecord = error as { name?: unknown; message?: unknown };
  const name = typeof errorRecord?.name === 'string' ? errorRecord.name.toLowerCase() : '';
  const message = typeof errorRecord?.message === 'string' ? errorRecord.message.toLowerCase() : '';
  if (name.includes('abort') || name.includes('cancel') || message.includes('abort') || message.includes('cancel')) return 'aborted';
  if (name.includes('timeout') || message.includes('timeout')) return 'timeout';
  const isFetchNetworkFailure = name === 'typeerror' && (message.includes('failed to fetch') || message.includes('load failed'));
  if (isFetchNetworkFailure || message.includes('network') || message.includes('offline')) return 'network_error';
  return null;
};
